import * as moment from 'moment-timezone'
import timezoneChecker from './timezoneChecker'

export default function (value, format = 'DD.MM.YYYY, HH:mm') {
    if (value) {
        let dateValue = null
        const {isDifferentTimeZone, isSummerTime} = timezoneChecker()
        if (isDifferentTimeZone) {
            dateValue = moment(value).utc().add(!!isSummerTime ? 120 : 60, 'm')
        } else {
            dateValue = String(value)
        }
        return moment(dateValue).format(format)
    }
}
